import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import {
  CLUB_SLUG_STORAGE_KEY,
  getStoredClubSlug,
  removeStoredClubSlug,
  setStoredClubSlug,
} from "@whoosh/relay/src";

type Session = {
  user: {
    id: string;
    email: string;
    username: string;
    clubs: SessionClub[];
  };
};

export type SessionClub = {
  id: string;
  slug: string;
  name: string;
  logoImage: string;
  supportsPublic?: boolean;
};

export const SESSION_CURRENT_CLUB_SLUG_STORAGE_KEY = CLUB_SLUG_STORAGE_KEY;
export const getStoredSessionCurrentClubSlug = getStoredClubSlug;

const storage = {
  getItem: async () => getStoredClubSlug(),
  removeItem: async () => removeStoredClubSlug(),
  setItem: async (_key: string, clubSlug: null | string) => {
    if (clubSlug) {
      await setStoredClubSlug(clubSlug);
    } else {
      await removeStoredClubSlug();
    }
  },
};

export const sessionCurrentClubSlugAtom = atomWithStorage<string | null>(
  CLUB_SLUG_STORAGE_KEY,
  null,
  storage,
  { getOnInit: true }
);

export const sessionCurrentClubAtom = atom<SessionClub | null>(null);

export const sessionAtom = atom<Session | null>(null);

export const sessionQueryVersionAtom = atom(0);

export const sessionUserAtom = atom((get) => {
  const session = get(sessionAtom);
  return session?.user || null;
});

export const sessionClubsAtom = atom((get) => {
  const session = get(sessionAtom);
  return session?.user.clubs || [];
});

export const showClubSwitcherModalAtom = atom<boolean>(false);

export const hasAdminRequestErrorAtom = atom<boolean>(false);

export const sessionCurrentClubSupportsPublicAtom = atom((get) => {
  const club = get(sessionCurrentClubAtom);
  return club?.supportsPublic || null;
});
